import { FCP } from 'types';

import { importStatic } from 'utils';

interface ICompanyAnonReviewSubmitSuccessProps extends FCP {
  title: string | JSX.Element;
  subTitle: string | JSX.Element;
  titleClassName?: string;
  subTitleClassName?: string;
}

const CompanyAnonReviewSuccess = ({
  title,
  subTitle,
  className = '',
  titleClassName = '',
  subTitleClassName = '',
}: ICompanyAnonReviewSubmitSuccessProps) => {
  return (
    <div className={className}>
      <p className={titleClassName}>
        <img
          src={importStatic('/ui-router/images/rounded-check.svg')}
          alt="check"
          className={'z-mr-12'}
        />
        {title}
      </p>
      <div className={subTitleClassName}>
        <img
          width={100}
          height={100}
          className="z-mt-24 z-mt-md-0"
          src={importStatic('/ui-router/images/footer/zippi-homepage.svg')}
        />
        {subTitle}
      </div>
    </div>
  );
};

export default CompanyAnonReviewSuccess;
